import { Row, Col } from "antd";
import { useEffect, useState } from "react";
import { useUserFavorites } from "../../api/Favorites";
import CaregiverCard from "../../components/CaregiverDisplay/CaregiverCard";
import UserDisplay, { UserDisplayCard } from "../../components/UserDisplay";
import ContentLayout, { ContentTitle } from "../../layout/ContentLayout";

const Favorites = () => {
  const [favoriteCaregivers, setFavoriteCaregivers] = useState([]);
  const { data } = useUserFavorites();

  useEffect(() => {
    if (data?.favorites) {
      let favs = [];
      data.favorites.forEach((f) => {
        if (f.ItemCategory === "caregiver") favs.push(f);
      });
      setFavoriteCaregivers(favs);
    }
  }, [data]);

  return (
    <ContentLayout>
      <ContentTitle>Favorites</ContentTitle>
      <Row gutter={[24, 24]}>
        {favoriteCaregivers.map((f) => (
          <Col key={f?.ItemId} xs={24} md={8}>
            <CaregiverCard
              key={f?.ItemId}
              userId={f?.ItemId}
              favorites={favoriteCaregivers}
            />
          </Col>
        ))}
      </Row>
    </ContentLayout>
  );
};

export default Favorites;
